import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/residents/new")({
  component: () => <div>Hello /_authenticated/residents/new!</div>,
});
